<footer class="footer gap-6 w-full text-gray-700">
  <mat-divider></mat-divider>
  <div class="flex justify-between max-w-6xl w-full mx-auto">
    <span class="">&#169; {{ currentYear }} {{ "COPYRIGHT" | translate }}</span>
    <a
      mat-flat-button
      [href]="
        'https://business.captire.com/dataprotection' +
        (selectedLanguage() === 'de' ? '' : '-' + selectedLanguage())
      "
      target="_blank"
      rel="noopener noreferrer"
      class="ml-4 link-style"
      >
        {{ "DATA_PROTECTION" | translate }}
      </a>
  </div>
</footer>
